module.exports = __webpack_public_path__ + "6bce6075e1dc711150fa1881134a5ffd.pdf";